import { render, staticRenderFns } from "./DynamicStatuses.vue?vue&type=template&id=56962874&"
import script from "./DynamicStatuses.vue?vue&type=script&lang=js&"
export * from "./DynamicStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports